import {IdSharedValueObject} from '../../shared/ValueObjects/IdSharedValueObject.js'
import {ComparatorAdAdsError} from '../Errors/ComparatorAdAdsError.js'

export class ComparatorAdAdsValueObject {
  #fuelType
  #id
  #img
  #price
  #title
  #year

  constructor({fuelType, id, img, photos, price, title, year}) {
    this.#fuelType = fuelType
    this.#id = id
    this.#img = img || photos[0]
    this.#price = price
    this.#title = title
    this.#year = year
  }

  static isValid(ad) {
    return ComparatorAdAdsValueObject.safeValidate(ad)
  }

  static safeValidate({id}) {
    return IdSharedValueObject.safeValidate({id})
  }

  static validate({id}) {
    try {
      IdSharedValueObject.validate({id})
    } catch (error) {
      throw ComparatorAdAdsError.createInvalidAdError({cause: error})
    }
  }

  // To-do: Adapt this method to the new AdEntity when it is created
  static create({fuelType, id, img, photos, price, title, year}) {
    ComparatorAdAdsValueObject.validate({id})
    return new ComparatorAdAdsValueObject({
      fuelType,
      id: IdSharedValueObject.createFromPrimitives({id}),
      img,
      photos,
      price,
      title,
      year
    })
  }

  get fuelType() {
    return this.#fuelType
  }

  get id() {
    return this.#id.value
  }

  get img() {
    return this.#img
  }

  get price() {
    return this.#price
  }

  get title() {
    return this.#title
  }

  get year() {
    return this.#year
  }

  get value() {
    return {
      fuelType: this.fuelType,
      id: this.id,
      img: this.img,
      price: this.price,
      title: this.title,
      year: this.year
    }
  }

  toJSON() {
    return {
      fuelType: this.#fuelType,
      id: this.#id.toJSON(),
      img: this.#img,
      price: this.#price,
      title: this.#title,
      year: this.#year
    }
  }
}
